import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ITravaConsumo } from "../../../models/geo-veles/ITravaConsumo"
//import { IFormError, IFormProps } from "../../utils"


interface ITravaConsumoState {
    data: ITravaConsumo
}

const initialState: ITravaConsumoState = {
    data: {
        travaConsumo: {
            ClienteConsumiu: 0,
            ClienteTravaTem: false,
            ClienteTravaQuantidade: 0,
            Id: 0,
            IdCliente: 0,
            IdPerfil: 0,
            PerfilTravaTem: false,
            PerfilTravaQuantidade: 0,
            PerfilConsumiu: 0,
            IdUsuario: 0,
            UsuarioConsumiu: 0,
            UsuarioTravaTem: false,
            UsuarioTravaQuantidade: 0
        },
        quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor: 0,
        quantidadeMaximaExtracaoPermitadaPorVendedor: 0
    }
}

const travaConsumoSlice = createSlice({
    name: 'travaConsumo',
    initialState,
    reducers: {
        setTravaConsumoState(state, action: PayloadAction<ITravaConsumo>) {
            state.data = action.payload
        },
        resetTravaConsumoState(state) {
            state.data = initialState.data
        }
    }
})

export const {
    
    setTravaConsumoState,
    resetTravaConsumoState
} = travaConsumoSlice.actions

export const travaConsumoReducer = travaConsumoSlice.reducer